/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { QuoteTestGroupMetadata } from "./QuoteTestGroupMetadata";
import {
  QuoteTestGroupMetadataFromJSON,
  QuoteTestGroupMetadataFromJSONTyped,
  QuoteTestGroupMetadataToJSON,
  QuoteTestGroupMetadataToJSONTyped,
} from "./QuoteTestGroupMetadata";

/**
 *
 * @export
 * @interface PostQuoteTestGroupBody
 */
export interface PostQuoteTestGroupBody {
  /**
   *
   * @type {string}
   * @memberof PostQuoteTestGroupBody
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof PostQuoteTestGroupBody
   */
  serviceIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof PostQuoteTestGroupBody
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof PostQuoteTestGroupBody
   */
  description: string;
  /**
   *
   * @type {QuoteTestGroupMetadata}
   * @memberof PostQuoteTestGroupBody
   */
  metadata?: QuoteTestGroupMetadata | null;
}

/**
 * Check if a given object implements the PostQuoteTestGroupBody interface.
 */
export function instanceOfPostQuoteTestGroupBody(
  value: object,
): value is PostQuoteTestGroupBody {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (
    !("serviceIdentifier" in value) ||
    value["serviceIdentifier"] === undefined
  )
    return false;
  if (!("title" in value) || value["title"] === undefined) return false;
  if (!("description" in value) || value["description"] === undefined)
    return false;
  return true;
}

export function PostQuoteTestGroupBodyFromJSON(
  json: any,
): PostQuoteTestGroupBody {
  return PostQuoteTestGroupBodyFromJSONTyped(json, false);
}

export function PostQuoteTestGroupBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PostQuoteTestGroupBody {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    serviceIdentifier: json["serviceIdentifier"],
    title: json["title"],
    description: json["description"],
    metadata:
      json["metadata"] == null
        ? undefined
        : QuoteTestGroupMetadataFromJSON(json["metadata"]),
  };
}

export function PostQuoteTestGroupBodyToJSON(
  json: any,
): PostQuoteTestGroupBody {
  return PostQuoteTestGroupBodyToJSONTyped(json, false);
}

export function PostQuoteTestGroupBodyToJSONTyped(
  value?: PostQuoteTestGroupBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    serviceIdentifier: value["serviceIdentifier"],
    title: value["title"],
    description: value["description"],
    metadata: QuoteTestGroupMetadataToJSON(value["metadata"]),
  };
}
